function extraFields() {
	var extraSelect = $('#type-of-user');
	var extraSelectedClass = 'is-selected';
	var extraValueEntrepreneur = 'Entrepreneur';
	var extraValueInvestor = 'Investor';
	var extraFields = $('.extraFields');
	var extraEntrepreneur = $('.extraFields--entrepreneur');
	var extraInvestor = $('.extraFields--investor');
	extraSelect.on("change", function() {
		if($(this).val() == extraValueEntrepreneur) {
			extraRemoveClass();
			extraEntrepreneur.addClass(extraSelectedClass);
		}
		else if ($(this).val() == extraValueInvestor){
			extraRemoveClass();
			extraInvestor.addClass(extraSelectedClass);
		}
		else {
			extraRemoveClass();
		}
		function extraRemoveClass() {
			extraFields.removeClass(extraSelectedClass)
		}
	})
}